import { MAKE_AN_OFFER_COUNT_URL, MAKE_AN_OFFER_DETAILS_FILTER_URL, MAKE_AN_OFFER_DETAILS_URL, MAKE_AN_OFFER_LIST_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const makeanOffer = (props) => onResponse => {
    try {
        axiosInstance.post(MAKE_AN_OFFER_DETAILS_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const makeanOfferCount = (task_details) => onResponse => {
    try {
        axiosInstance.post(MAKE_AN_OFFER_COUNT_URL, { task_details })
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getMakeAnOfferListing = (props) => onResponse => {
    try {
        axiosInstance.get(MAKE_AN_OFFER_LIST_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const makeanOfferListFilter = (props) => onResponse => {
    try {
        axiosInstance.post(MAKE_AN_OFFER_DETAILS_FILTER_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};